import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

// Disable React/Webpack Overlay and show errors only in console
(function () {
  // Disable React DevTools hook injection if present
  if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = function () {};
  }

  // Prevent React error overlays
  window.addEventListener(
    "error",
    (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      console.error("⚠️ Error captured:", e.error || e.message);
      return false;
    },
    true
  );

  window.addEventListener(
    "unhandledrejection",
    (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      console.error("⚠️ Promise rejection captured:", e.reason);
      return false;
    },
    true
  );

  // Remove Webpack / Next.js overlays when they appear
  const observer = new MutationObserver(() => {
    document
      .querySelectorAll(
        "iframe[style*='z-index'], nextjs-portal, [data-nextjs-dialog-overlay]"
      )
      .forEach((el) => el.remove());
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
